module.exports = __webpack_public_path__ + "static/media/torben.7be39495.jpg";